export const FIO_EMPTY_ERROR_CYRILLIC = 'ФИО может состоять только из кириллицы';
export const FIO_EMPTY_ERROR_FIRST_CYRILLIC_CHARACTER = 'ФИО может начинаться только с кириллицы';
export const FIO_EMPTY_ERROR_WHITESPACE_AND_HYPHEN =
    'Между словами разрешены одиночные пробелы или одиночные дефисы';

export const validateFioEmptyValue = (value: string) => {
    if (!value) return undefined;

    if (!/^[\sЁА-яё-]*$/.test(value)) {
        return FIO_EMPTY_ERROR_CYRILLIC;
    }

    if (!/^\s*[ЁА-яё]/.test(value)) {
        return FIO_EMPTY_ERROR_FIRST_CYRILLIC_CHARACTER;
    }

    if (!/^\s*[ЁА-яё]+([ -][ЁА-яё]+)*\s?$/.test(value)) {
        return FIO_EMPTY_ERROR_WHITESPACE_AND_HYPHEN;
    }

    return undefined;
};
